import React from "react";
import { Progress } from "reactstrap";
import { RightArrow } from "../../../assets/images";
import TableLoader from "../Table/TableLoader";
type AppProps = {
  attendenceData: any;
  totalAttendanceHours: number;
  fetching: boolean;
  stylingType?: string;
};
const AttendanceList = ({
  attendenceData,
  totalAttendanceHours,
  fetching,
  stylingType,
}: AppProps) => {
  return (
    <div className="mt-3">
      {attendenceData?.length &&
      attendenceData[attendenceData?.length - 1]?.end_time != null ? (
        <div
          className="mb-2 d-flex align-items-center justify-content-center"
          style={{ paddingLeft: "24px", paddingRight: "32px" }}
        >
          <Progress
            striped
            style={{
              height: "15px",
              marginRight: "10px",
              width: "80%",
              backgroundColor: "#bfcbe1",
            }}
            value={totalAttendanceHours}
            max={12}
            color={totalAttendanceHours >= 12 ? "warning" : "success"}
          ></Progress>
          <span style={{ marginRight: "10px" }}>
            {!!totalAttendanceHours ? totalAttendanceHours?.toFixed(2) : "0:00"}
            /12:00
          </span>
        </div>
      ) : (
        ""
      )}
      <div
        style={{
          overflow: "auto",
          // height: "30vh",
          height: `${
            attendenceData?.length &&
            attendenceData[attendenceData?.length - 1]?.end_time == null &&
            !fetching &&
            attendenceData?.length !== 0
              ? "0vh"
              : stylingType
              ? "60vh"
              : "30vh"
          }`,
          paddingLeft: "31px",
          paddingRight: "32px",
        }}
      >
        <table className="thead-light" style={{ width: "100%" }}>
          {attendenceData?.length &&
          attendenceData[attendenceData?.length - 1]?.end_time != null ? (
            <thead className="text-start" style={{ backgroundColor: "white" }}>
              <tr
                className="text-nowrap"
                style={{ color: "#6e7491", fontSize: "14px" }}
              >
                <td>Start Time</td>
                <td></td>
                <td>End Time</td>
                <td>Total Hours</td>
                {stylingType?.length ? (
                  <>
                    <td>Start Location</td>
                    <td>End Location</td>
                  </>
                ) : (
                  ""
                )}
              </tr>
            </thead>
          ) : (
            ""
          )}
          <tbody>
            {attendenceData?.length > 0
              ? attendenceData?.map((data: any) => {
                  return (
                    <>
                      {" "}
                      {data?.gap_time ? (
                        <tr
                          className="text-nowrap"
                          style={{
                            width: "100%",
                            borderRadius: "2px",
                            border: "1px solid #be7e12",
                          }}
                        >
                          <td
                            colSpan={stylingType ? 6 : 4}
                            className="mb-3"
                            style={{
                              color: "#be7e12",
                              fontSize: "15px",
                              padding: "4px 14px",
                              height: "30px",
                              backgroundColor: "#fff5e5",
                            }}
                          >
                            <span style={{ fontWeight: "500" }}>
                              Break Time - {data?.gap_time}
                            </span>
                          </td>
                        </tr>
                      ) : data?.end_time != null ? (
                        <tr>
                          <td
                            className="pb-2 pt-2"
                            style={{
                              color: "#262a44",
                              fontWeight: "500",
                              fontSize: "18px",
                              width: stylingType ? "12%" : "32%",
                            }}
                          >
                            {
                              data?.start_time
                                ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                ?.filter(Boolean)[0]
                            }{" "}
                            {data?.start_time
                              ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                              .filter(Boolean)[1]
                              .toUpperCase()}
                          </td>
                          <td
                            className="pb-2 pt-2 pr-4"
                            style={{ width: "5%" }}
                          >
                            <span>
                              <img src={RightArrow} />
                            </span>
                          </td>
                          <td
                            className="pb-2 pt-2"
                            style={{
                              color: "#262a44",
                              fontWeight: "500",
                              fontSize: "18px",
                              width: stylingType ? "12%" : "32%",
                            }}
                          >
                            {
                              data?.end_time
                                ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                ?.filter(Boolean)[0]
                            }{" "}
                            {data?.end_time
                              ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                              .filter(Boolean)[1]
                              .toUpperCase()}
                          </td>
                          <td
                            className="pb-2 pt-2"
                            style={{
                              color: "#262a44",
                              fontWeight: "500",
                              fontSize: "18px",
                              width: stylingType ? "12%" : "18%",
                            }}
                          >
                            {!!data?.time_difference
                              ? data?.time_difference?.toFixed(2)
                              : "0.00"}
                          </td>
                          {stylingType?.length ? (
                            <>
                              <td
                                className="pb-2 pt-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                  width: "30%",
                                  paddingRight: "8px",
                                }}
                              >
                                {!!data?.start_location
                                  ? data?.start_location
                                  : "--/--"}
                              </td>
                              <td
                                className="pb-2 pt-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                  width: "30%",
                                }}
                              >
                                {!!data?.end_location
                                  ? data?.end_location
                                  : "--/--"}
                              </td>
                            </>
                          ) : (
                            ""
                          )}
                        </tr>
                      ) : (
                        <tr>
                          <td className="pb-2"></td>
                        </tr>
                      )}
                    </>
                  );
                })
              : attendenceData?.length === 0 &&
                fetching && <TableLoader Rows={5} ColumnPerRow={3} />}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceList;
